function initProjectsMap() {
    const mapEl = document.getElementById('projects-map');
    if (mapEl !== null && !mapEl.dataset.inited) {
        mapEl.dataset.inited = '1';
        const dataEl = document.getElementById('projects-map-data');
        let projectCoordinates = dataEl ? JSON.parse(dataEl.textContent) : [];
        mapboxgl.accessToken = 'pk.eyJ1Ijoic3R1ZGlvYXZkbSIsImEiOiJja3BtYzF1aDgwNWRqMnVwZzFuaWp4cWQ1In0.cM_kXrg7IKxIn9HoKWT6Ig';
        const map = new mapboxgl.Map({
            container: 'projects-map',
            // Choose from Mapbox's core styles, or make your own style with Mapbox Studio
            style: 'mapbox://styles/studioavdm/cm7dclvot000c01r31y2u88u1',
            center: [4.3085, 51.9428],
            // scrollZoom: false,
            // doubleClickZoom: true,
            minZoom: 6,
            zoom: 7
        });
        map.addControl(new mapboxgl.NavigationControl());
        map.on('load', () => {
            map.addSource('projects', {
                type: 'geojson',
                data: { "type": "FeatureCollection",
                    "features": projectCoordinates
                },
                cluster: true,
                clusterMaxZoom: 30,
                clusterRadius: 50,
            });

            map.addLayer({
                id: 'clusters',
                type: 'circle',
                source: 'projects',
                filter: ['has', 'point_count'],
                paint: {
                    // Use step expressions (https://docs.mapbox.com/style-spec/reference/expressions/#step)
                    // with three steps to implement three types of circles:
                    //   * Blue, 20px circles when point count is less than 100
                    //   * Yellow, 30px circles when point count is between 100 and 750
                    //   * Pink, 40px circles when point count is greater than or equal to 750
                    'circle-color': [
                        'step',
                        ['get', 'point_count'],
                        '#FF1900',
                        3,
                        '#D9232D',
                        10,
                        '#BE2817'
                    ],
                    'circle-radius': [
                        'step',
                        ['get', 'point_count'],
                        20,
                        3,
                        30,
                        10,
                        40
                    ]
                }
            });

            map.addLayer({
                id: 'cluster-count',
                type: 'symbol',
                source: 'projects',
                filter: ['has', 'point_count'],
                layout: {
                    'text-field': ['get', 'point_count_abbreviated'],
                    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
                    'text-size': 12
                }
            });

            map.addLayer({
                id: 'unclustered-point',
                source: 'projects',
                type: 'circle',
                filter: ['!', ['has', 'point_count']],
                paint: {
                    'circle-color': '#E52713',
                    'circle-radius': 6,
                    'circle-stroke-width': 1,
                    'circle-stroke-color': '#fff'
                }
            });

            function buildPopupContent({ title, location, status, url }) {
                const content = document.createElement('div');
                content.className = 'map-popup';

                const titleEl = document.createElement('div');
                titleEl.className = 'map-popup__title';
                titleEl.textContent = title;

                const locationEl = document.createElement('div');
                locationEl.className = 'map-popup__location';
                locationEl.textContent = location;

                const statusEl = document.createElement('div');
                statusEl.className = 'map-popup__status';
                statusEl.textContent = status;

                const link = document.createElement('a');
                link.className = 'map-popup__link';
                link.href = url;
                link.textContent = 'Bekijk dit project';

                content.append(titleEl, locationEl, statusEl, link);
                return content;
            }

            let hoverPopup = null;
            let hoverCloseTimeout = null;

            function closeHoverPopup() {
                hoverCloseTimeout = setTimeout(() => {
                    if (hoverPopup) { hoverPopup.remove(); hoverPopup = null; }
                }, 200);
            }

            map.on('mouseenter', 'unclustered-point', (e) => {
                map.getCanvas().style.cursor = 'pointer';
                clearTimeout(hoverCloseTimeout);

                const coordinates = e.features[0].geometry.coordinates.slice();
                if (hoverPopup) hoverPopup.remove();
                hoverPopup = new mapboxgl.Popup({ closeButton: false })
                    .setLngLat(coordinates)
                    .setDOMContent(buildPopupContent(e.features[0].properties))
                    .addTo(map);

                // Popup open houden als de muis erin beweegt
                hoverPopup.getElement().addEventListener('mouseenter', () => {
                    clearTimeout(hoverCloseTimeout);
                });
                hoverPopup.getElement().addEventListener('mouseleave', closeHoverPopup);
            });

            map.on('mouseleave', 'unclustered-point', () => {
                map.getCanvas().style.cursor = '';
                closeHoverPopup();
            });

            map.on('click', 'unclustered-point', (e) => {
                if (e.originalEvent.pointerType === 'touch') {
                    // Touch: geen hover mogelijk → toon popup met link
                    const coordinates = e.features[0].geometry.coordinates.slice();
                    new mapboxgl.Popup()
                        .setLngLat(coordinates)
                        .setDOMContent(buildPopupContent(e.features[0].properties))
                        .addTo(map);
                } else {
                    // Muis: navigeer direct
                    window.location.href = e.features[0].properties.url;
                }
            });

            map.on('click', 'clusters', (e) => {
                const features = map.queryRenderedFeatures(e.point, { layers: ['clusters'] });
                const clusterId = features[0].properties.cluster_id;
                map.getSource('projects').getClusterExpansionZoom(clusterId, (err, zoom) => {
                    if (err) return;
                    map.easeTo({ center: features[0].geometry.coordinates, zoom });
                });
            });

            map.on('mouseenter', 'clusters', () => { map.getCanvas().style.cursor = 'pointer'; });
            map.on('mouseleave', 'clusters', () => { map.getCanvas().style.cursor = ''; });
        })
    }
}

document.addEventListener("livewire:init", () => {
    Livewire.on('updatedProjects', () => {
        setTimeout(() => initProjectsMap(), 350);
    });
});
